import my_cv from './../../assets/webp/projects/my_cv.webp'
import Dressify from './../../assets/webp/projects/Dressify.webp'
import Monster from './../../assets/webp/projects/Monster.webp'
import PickCart from './../../assets/webp/projects/PickCart.webp'
import Space_Ludo from './../../assets/webp/projects/Space_Ludo.webp'
import Fitra_ from './../../assets/webp/projects/Fitra_.webp'
import Retro_Player from './../../assets/webp/projects/Retro_Player.webp'
import Game_Space from './../../assets/webp/projects/Game_Space.webp'
import Weather_With from './../../assets/webp/projects/Weather_With.webp'

export const projects = {
    my_cv,
    Dressify,
    Monster,
    PickCart,
    Space_Ludo,
    Fitra_,
    Retro_Player,
    Game_Space,
    Weather_With,
}